/* eslint-disable no-magic-numbers */
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Option as SelectOption, Select } from 'carbon-react/lib/components/select';

import { getOrdinalSuffix } from '@futrli/localisation/core/utils';

import * as styles from './recurrence-settings.scss';
import { THE_LAST } from './types';

interface MonthDaySelectProps {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const MonthDaySelect = ({ value, onChange }: MonthDaySelectProps) => {
  const intl = useIntl();

  return (
    <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
      <Select
        label={intl.formatMessage({ id: 'common.on_nth_day_of_month', defaultMessage: 'On' })}
        autoComplete="off"
        mr="10px"
        style={{ width: 90 }}
        mb="0px"
        onChange={onChange}
        value={value}
        size="medium"
        required
      >
        <SelectOption
          key={THE_LAST}
          value={THE_LAST}
          text={intl.formatMessage({ id: 'common.the_last_capital', defaultMessage: 'The last' })}
        />
        {[...Array(32).keys()].slice(1).map(i => (
          <SelectOption key={`option_${i}`} value={String(i)} text={getOrdinalSuffix(i, intl.locale)} />
        ))}
      </Select>
      <div style={{ fontWeight: 400, marginTop: 29 }} className={styles.labelFont}>
        <FormattedMessage id="common.day_of_month_capital" defaultMessage="Day of the month" />
      </div>
    </div>
  );
};
